<template>
  <div class="result-container">
    <transition name="fade" appear mode="out-in">
      <div v-if="resultsData.amount_range.EUR[1] < 1">
        <p>
          {{$t('message.results.noresult')}}
          <br />
        </p>
      </div>
      <div v-else>
        <transition name="fade" mode="out-in">
          <p :key="selectedCurrency" v-html="$t('message.results.musicRights', {min: amount.min, max: amount.max, currency:selectedCurrency})">
          </p>
        </transition>
      </div>
    </transition>
    <div
      class="results-light"
      v-if="
        resultsData.music_streaming &&
          resultsData.music_streaming.master_percentage > 0
      "
    >
      <p v-html="$t('message.results.masterRights', {master:resultsData.music_streaming.master_percentage, publishing: resultsData.music_streaming.publishing_percentage })">
      </p>
    </div>
    <div class="results-light" v-if="resultsData.amount_range.EUR[1] >= 1">
      <p>{{$t('message.results.collectText')}}</p>
    </div>
    <div class="results-light">
      <p>
        <a href="mailto:hello@weare440.com">{{$t('message.results.getInTouch')}}</a> |
        <a :href="wpData.site_url + $t('message.url.formUrl')"
          >{{$t('message.results.startNew')}}</a
        >
      </p>
      <p class="small-font" v-if="resultsData.amount_range.EUR[1] >= 1">
        {{$t('message.results.otherCurrency')}}
        <br />
        <span class="currencyBtn" @click="selectedCurrency = 'USD'"
          >USD ($)</span
        >
        <span class="currencyBtn" @click="selectedCurrency = 'EUR'"
          >EUR (€)</span
        >
        <span class="currencyBtn" @click="selectedCurrency = 'GBP'"
          >GBP (£)</span
        >
      </p>
      <hr />
      <p class="small-font">
        <em v-html="$t('message.results.mentions')">
        </em>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: ["wpData", "resultsData"],
  data() {
    return {
      selectedCurrency: "EUR",
    };
  },
  computed: {
    amountRange() {
      return this.resultsData.amount_range;
    },
    amount() {
      return {
        min: this.amountRange[this.selectedCurrency][0].toLocaleString([this.$i18n.locale]),
        max: this.amountRange[this.selectedCurrency][1].toLocaleString([this.$i18n.locale]),
      };
    },
  },
};
</script>

<style>
.result-container {
  margin-bottom:30px;
}

.result-container p {
  line-height: 1.6em;
  font-size: 1.2em;
}

.result-container a {
  color: #fff;
  text-decoration: underline;
}

.result-container .small-font {
  font-size: 0.9em;
}

.result-container .big-font {
  font-size: 1.2em;
  font-weight: bold;
}

.result-container .results-light {
  margin: 15px 0;
  max-width: 600px;
}

.result-container .currencyBtn {
  cursor: pointer;
  color: #000;
  font-size: 16px;
  margin-right: 10px;
  transition: 0.3s;
}
.result-container .currencyBtn:hover {
  color: #fff;
  font-weight: bold;
}

.result-container .thank-you-img {
  max-width: 300px;
}

@media screen and (max-width: 768px) {
  .result-container div {
    text-align: center;
  }
}
</style>
